import { ICalculationDefaultsApiRequest } from '@/features/project-information/api/calculation-defaults';

export const ProjectInformationKeys = {
  calculationDefaults: ({ calculationId }: ICalculationDefaultsApiRequest) => [
    'calculationDefaults',
    calculationId
  ]
};
